import React from 'react';
import classNames from 'classnames';
import s from './s.module.less';

interface Step {
    id: number;
    title: string;
}

interface StepIndicatorProps {
    steps: Step[];
    currentStep: number;
    onStepClick?: (stepId: number) => void;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ steps, currentStep, onStepClick }) => {
    return (
        <div className={s.stepIndicator}>
            {steps.map((step, index) => {
                const isActive = step.id === currentStep;
                const isCompleted = step.id < currentStep;

                return (
                    <div
                        key={step.id}
                        className={s.stepWrapper}
                        onClick={() => onStepClick && onStepClick(step.id)}
                    >
                        <div className={s.stepContainer}>
                            <div
                                className={classNames(s.progressLine, {
                                    [s.active]: isActive || isCompleted,
                                })}
                            />
                            <div className={s.stepLabelContainer}>
                                <div
                                    className={classNames(s.stepLabel, {
                                        [s.activeLabel]: isActive,
                                        [s.completedLabel]: isCompleted,
                                    })}
                                >
                                    STEP {index + 1}
                                </div>
                                <div
                                    className={s.stepTitle}
                                >
                                    {step.title}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default StepIndicator;
